export const formatFloatToInteger = (value) => {
  return value?.toFixed(0);
};
